export function addDaysToDate(date, days) {
  const initialDate = new Date(date);
  const newDate = initialDate.getDate() + days;

  return initialDate.setDate(newDate);
}
